import { InjectionToken } from '@angular/core';

export interface DatastoreFakeConfig {
  readonly initializeFake: boolean;
}

export const DATASTORE_FAKE_CONFIG = new InjectionToken<DatastoreFakeConfig>(
  'Datastore Configuration',
);
